/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Regenerated by `npm run cms:sync` from /api/cms/public/media-index.
 */

export interface CmsMediaIndexEntry {
  urls: { thumb?: string; small?: string; medium?: string; large?: string; xlarge?: string; original: string }
  widths: { thumb?: number; small?: number; medium?: number; large?: number; xlarge?: number }
  alt: { 'zh-Hant': string; 'zh-Hans': string; en: string }
  width: number | null
  height: number | null
}

export const cmsMediaIndex: Record<string, CmsMediaIndexEntry> = {
  "fae4984b-4811-4bec-98ba-f45f2b5a56da": {
    "urls": {
      "original": "/uploads/2026-10/fae4984b-4811-4bec-98ba-f45f2b5a56da.png",
      "thumb": "/uploads/2026-10/fae4984b-4811-4bec-98ba-f45f2b5a56da.thumb.webp",
      "medium": "/uploads/2026-10/fae4984b-4811-4bec-98ba-f45f2b5a56da.medium.webp",
      "small": "/uploads/2026-10/fae4984b-4811-4bec-98ba-f45f2b5a56da.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 763
    },
    "alt": {
      "zh-Hant": "學生正面校園首頁：解鎖獎卡與家長專區",
      "zh-Hans": "学生正面校园首页：解锁奖卡与家长专区",
      "en": ""
    },
    "width": 763,
    "height": 849
  },
  "41b2d89a-833d-4090-ad68-504e1f9b0c34": {
    "urls": {
      "original": "/uploads/2026-10/41b2d89a-833d-4090-ad68-504e1f9b0c34.png",
      "thumb": "/uploads/2026-10/41b2d89a-833d-4090-ad68-504e1f9b0c34.thumb.webp",
      "medium": "/uploads/2026-10/41b2d89a-833d-4090-ad68-504e1f9b0c34.medium.webp",
      "small": "/uploads/2026-10/41b2d89a-833d-4090-ad68-504e1f9b0c34.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "品格價值管理介面：自訂價值、卡面與雙語名稱",
      "zh-Hans": "品格价值管理介面：自订价值、卡面与双语名称",
      "en": ""
    },
    "width": 1105,
    "height": 898
  },
  "a297c0ca-d2c9-4676-8cc2-a8fbf847c1d9": {
    "urls": {
      "original": "/uploads/2026-10/a297c0ca-d2c9-4676-8cc2-a8fbf847c1d9.png",
      "thumb": "/uploads/2026-10/a297c0ca-d2c9-4676-8cc2-a8fbf847c1d9.thumb.webp",
      "medium": "/uploads/2026-10/a297c0ca-d2c9-4676-8cc2-a8fbf847c1d9.medium.webp",
      "small": "/uploads/2026-10/a297c0ca-d2c9-4676-8cc2-a8fbf847c1d9.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 904
    },
    "alt": {
      "zh-Hant": "教師管理後台儀表板：庫存統計與解鎖分析圖表",
      "zh-Hans": "教师管理后台仪表板：库存统计与解锁分析图表",
      "en": ""
    },
    "width": 904,
    "height": 800
  },
  "d6c27aa3-acd5-499b-ae33-5fbbd7ee79df": {
    "urls": {
      "original": "/uploads/2026-10/d6c27aa3-acd5-499b-ae33-5fbbd7ee79df.png",
      "thumb": "/uploads/2026-10/d6c27aa3-acd5-499b-ae33-5fbbd7ee79df.thumb.webp",
      "medium": "/uploads/2026-10/d6c27aa3-acd5-499b-ae33-5fbbd7ee79df.medium.webp"
    },
    "widths": {
      "thumb": 320,
      "medium": 599
    },
    "alt": {
      "zh-Hant": "成就頁面：獎章等級與達標計劃進度",
      "zh-Hans": "成就页面：奖章等级与达标计划进度",
      "en": ""
    },
    "width": 599,
    "height": 820
  },
  "624b1e32-06e1-4045-84b1-64bf8e15e451": {
    "urls": {
      "original": "/uploads/2026-10/624b1e32-06e1-4045-84b1-64bf8e15e451.png",
      "thumb": "/uploads/2026-10/624b1e32-06e1-4045-84b1-64bf8e15e451.thumb.webp",
      "medium": "/uploads/2026-10/624b1e32-06e1-4045-84b1-64bf8e15e451.medium.webp"
    },
    "widths": {
      "thumb": 320,
      "medium": 484
    },
    "alt": {
      "zh-Hant": "學生／家長總覽：解鎖紀錄與成就標籤",
      "zh-Hans": "学生／家长总览：解锁纪录与成就标签",
      "en": ""
    },
    "width": 484,
    "height": 830
  },
  "314091a6-e8d5-47ea-80c0-3828b0ee18f1": {
    "urls": {
      "original": "/uploads/2026-10/314091a6-e8d5-47ea-80c0-3828b0ee18f1.png",
      "thumb": "/uploads/2026-10/314091a6-e8d5-47ea-80c0-3828b0ee18f1.thumb.webp",
      "medium": "/uploads/2026-10/314091a6-e8d5-47ea-80c0-3828b0ee18f1.medium.webp"
    },
    "widths": {
      "thumb": 320,
      "medium": 619
    },
    "alt": {
      "zh-Hant": "《教育專業》第 49 期封面",
      "zh-Hans": "《教育专业》第 49 期封面",
      "en": ""
    },
    "width": 619,
    "height": 800
  },
  "a9c7f8d6-5753-4bfa-8cda-8c124f9e9610": {
    "urls": {
      "original": "/uploads/2026-10/a9c7f8d6-5753-4bfa-8cda-8c124f9e9610.jpeg",
      "thumb": "/uploads/2026-10/a9c7f8d6-5753-4bfa-8cda-8c124f9e9610.thumb.webp",
      "medium": "/uploads/2026-10/a9c7f8d6-5753-4bfa-8cda-8c124f9e9610.medium.webp",
      "small": "/uploads/2026-10/a9c7f8d6-5753-4bfa-8cda-8c124f9e9610.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "《香港01》家長講座封面",
      "zh-Hans": "《香港01》家长讲座封面",
      "en": ""
    },
    "width": 1200,
    "height": 675
  },
  "336ec223-6029-44fe-9b06-ff1af257e096": {
    "urls": {
      "original": "/uploads/2026-10/336ec223-6029-44fe-9b06-ff1af257e096.png",
      "thumb": "/uploads/2026-10/336ec223-6029-44fe-9b06-ff1af257e096.thumb.webp",
      "medium": "/uploads/2026-10/336ec223-6029-44fe-9b06-ff1af257e096.medium.webp",
      "small": "/uploads/2026-10/336ec223-6029-44fe-9b06-ff1af257e096.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 712
    },
    "alt": {
      "zh-Hant": "《明報》數字公益進化之路（二之二）封面",
      "zh-Hans": "《明报》数字公益进化之路（二之二）封面",
      "en": ""
    },
    "width": 712,
    "height": 1430
  },
  "c5bce77d-d289-46fe-8d5c-517470968033": {
    "urls": {
      "original": "/uploads/2026-10/c5bce77d-d289-46fe-8d5c-517470968033.png",
      "thumb": "/uploads/2026-10/c5bce77d-d289-46fe-8d5c-517470968033.thumb.webp",
      "medium": "/uploads/2026-10/c5bce77d-d289-46fe-8d5c-517470968033.medium.webp"
    },
    "widths": {
      "thumb": 320,
      "medium": 610
    },
    "alt": {
      "zh-Hant": "《明報》數字公益進化之路（二之一）封面",
      "zh-Hans": "《明报》数字公益进化之路（二之一）封面",
      "en": ""
    },
    "width": 610,
    "height": 1414
  },
  "28bef794-03f9-4f00-b425-0dedc84895db": {
    "urls": {
      "original": "/uploads/2026-10/28bef794-03f9-4f00-b425-0dedc84895db.jpg",
      "thumb": "/uploads/2026-10/28bef794-03f9-4f00-b425-0dedc84895db.thumb.webp",
      "medium": "/uploads/2026-10/28bef794-03f9-4f00-b425-0dedc84895db.medium.webp",
      "small": "/uploads/2026-10/28bef794-03f9-4f00-b425-0dedc84895db.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "",
      "zh-Hans": "",
      "en": ""
    },
    "width": 1200,
    "height": 675
  },
  "717393a3-6234-4118-bb3c-0f82bba81a36": {
    "urls": {
      "original": "/uploads/2026-10/717393a3-6234-4118-bb3c-0f82bba81a36.jpg",
      "thumb": "/uploads/2026-10/717393a3-6234-4118-bb3c-0f82bba81a36.thumb.webp",
      "medium": "/uploads/2026-10/717393a3-6234-4118-bb3c-0f82bba81a36.medium.webp",
      "small": "/uploads/2026-10/717393a3-6234-4118-bb3c-0f82bba81a36.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 960
    },
    "alt": {
      "zh-Hant": "體育館內，參加者坐在分隔課桌前專心作答，現場秩序井然。",
      "zh-Hans": "学生在体育馆内分散就座答题，前方设有讲台。",
      "en": "Students sit at widely spaced desks taking an exam in a gymnasium."
    },
    "width": 960,
    "height": 540
  },
  "7448fd81-7bb5-49e8-9e98-c80595fd0604": {
    "urls": {
      "original": "/uploads/2026-10/7448fd81-7bb5-49e8-9e98-c80595fd0604.jpg",
      "medium": "/uploads/2026-10/7448fd81-7bb5-49e8-9e98-c80595fd0604.medium.webp",
      "thumb": "/uploads/2026-10/7448fd81-7bb5-49e8-9e98-c80595fd0604.thumb.webp",
      "small": "/uploads/2026-10/7448fd81-7bb5-49e8-9e98-c80595fd0604.small.webp",
      "large": "/uploads/2026-10/7448fd81-7bb5-49e8-9e98-c80595fd0604.large.webp",
      "xlarge": "/uploads/2026-10/7448fd81-7bb5-49e8-9e98-c80595fd0604.xlarge.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024,
      "large": 1600,
      "xlarge": 2048
    },
    "alt": {
      "zh-Hant": "清晨時分校門外的雙彩虹",
      "zh-Hans": "清晨时分校门外的双彩虹",
      "en": "A double rainbow seen outside the school gate in the early morning"
    },
    "width": 4096,
    "height": 3072
  },
  "33f9d308-fe1a-4fd3-af7b-a55fd2175d75": {
    "urls": {
      "original": "/uploads/2026-10/33f9d308-fe1a-4fd3-af7b-a55fd2175d75.jpg",
      "medium": "/uploads/2026-10/33f9d308-fe1a-4fd3-af7b-a55fd2175d75.medium.webp",
      "thumb": "/uploads/2026-10/33f9d308-fe1a-4fd3-af7b-a55fd2175d75.thumb.webp",
      "small": "/uploads/2026-10/33f9d308-fe1a-4fd3-af7b-a55fd2175d75.small.webp",
      "large": "/uploads/2026-10/33f9d308-fe1a-4fd3-af7b-a55fd2175d75.large.webp",
      "xlarge": "/uploads/2026-10/33f9d308-fe1a-4fd3-af7b-a55fd2175d75.xlarge.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024,
      "large": 1600,
      "xlarge": 2048
    },
    "alt": {
      "zh-Hant": "魏遠強總監與蒙養學校教師合照",
      "zh-Hans": "魏远强总监与蒙养学校教师合照",
      "en": "Group photo with the principal and teachers at Mong Yung Public School"
    },
    "width": 3072,
    "height": 2838
  },
  "3ddc1e85-8bfd-4049-9df7-f060f1c9eff7": {
    "urls": {
      "original": "/uploads/2026-10/3ddc1e85-8bfd-4049-9df7-f060f1c9eff7.jpg",
      "thumb": "/uploads/2026-10/3ddc1e85-8bfd-4049-9df7-f060f1c9eff7.thumb.webp",
      "medium": "/uploads/2026-10/3ddc1e85-8bfd-4049-9df7-f060f1c9eff7.medium.webp",
      "small": "/uploads/2026-10/3ddc1e85-8bfd-4049-9df7-f060f1c9eff7.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "每日推送微學習課程：課堂單元、自動生成、推送至手機、閒置時間學習",
      "zh-Hans": "每日推送微学习课程：课堂单元、自动生成、推送至手机、闲置时间学习",
      "en": ""
    },
    "width": 1400,
    "height": 711
  },
  "ff250b9e-dc34-4a9a-a785-abaf38260c17": {
    "urls": {
      "original": "/uploads/2026-10/ff250b9e-dc34-4a9a-a785-abaf38260c17.jpg",
      "thumb": "/uploads/2026-10/ff250b9e-dc34-4a9a-a785-abaf38260c17.thumb.webp",
      "medium": "/uploads/2026-10/ff250b9e-dc34-4a9a-a785-abaf38260c17.medium.webp",
      "small": "/uploads/2026-10/ff250b9e-dc34-4a9a-a785-abaf38260c17.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "",
      "zh-Hans": "",
      "en": ""
    },
    "width": 1379,
    "height": 919
  },
  "9873a722-d8c5-442a-82c5-df730a686e12": {
    "urls": {
      "original": "/uploads/2026-10/9873a722-d8c5-442a-82c5-df730a686e12.jpg",
      "thumb": "/uploads/2026-10/9873a722-d8c5-442a-82c5-df730a686e12.thumb.webp",
      "medium": "/uploads/2026-10/9873a722-d8c5-442a-82c5-df730a686e12.medium.webp",
      "small": "/uploads/2026-10/9873a722-d8c5-442a-82c5-df730a686e12.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "",
      "zh-Hans": "",
      "en": ""
    },
    "width": 1379,
    "height": 919
  },
  "56502cd5-2e6c-4bb2-8c96-ac2e848604b9": {
    "urls": {
      "original": "/uploads/2026-10/56502cd5-2e6c-4bb2-8c96-ac2e848604b9.jpg",
      "thumb": "/uploads/2026-10/56502cd5-2e6c-4bb2-8c96-ac2e848604b9.thumb.webp",
      "medium": "/uploads/2026-10/56502cd5-2e6c-4bb2-8c96-ac2e848604b9.medium.webp",
      "small": "/uploads/2026-10/56502cd5-2e6c-4bb2-8c96-ac2e848604b9.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "",
      "zh-Hans": "",
      "en": ""
    },
    "width": 1380,
    "height": 776
  },
  "a69f4763-ac15-4ca9-b49b-ad1859f15bd4": {
    "urls": {
      "original": "/uploads/2026-10/a69f4763-ac15-4ca9-b49b-ad1859f15bd4.jpg",
      "thumb": "/uploads/2026-10/a69f4763-ac15-4ca9-b49b-ad1859f15bd4.thumb.webp",
      "medium": "/uploads/2026-10/a69f4763-ac15-4ca9-b49b-ad1859f15bd4.medium.webp",
      "small": "/uploads/2026-10/a69f4763-ac15-4ca9-b49b-ad1859f15bd4.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "",
      "zh-Hans": "",
      "en": ""
    },
    "width": 1379,
    "height": 776
  },
  "99d7ed84-8c4d-4761-8da9-ed6ed72b2dc0": {
    "urls": {
      "original": "/uploads/2026-10/99d7ed84-8c4d-4761-8da9-ed6ed72b2dc0.jpg",
      "thumb": "/uploads/2026-10/99d7ed84-8c4d-4761-8da9-ed6ed72b2dc0.thumb.webp",
      "medium": "/uploads/2026-10/99d7ed84-8c4d-4761-8da9-ed6ed72b2dc0.medium.webp",
      "small": "/uploads/2026-10/99d7ed84-8c4d-4761-8da9-ed6ed72b2dc0.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "",
      "zh-Hans": "",
      "en": ""
    },
    "width": 1379,
    "height": 1034
  },
  "09459a3a-9201-4ab7-8319-a05a1cb7bbb9": {
    "urls": {
      "original": "/uploads/2026-10/09459a3a-9201-4ab7-8319-a05a1cb7bbb9.jpg",
      "thumb": "/uploads/2026-10/09459a3a-9201-4ab7-8319-a05a1cb7bbb9.thumb.webp",
      "medium": "/uploads/2026-10/09459a3a-9201-4ab7-8319-a05a1cb7bbb9.medium.webp",
      "small": "/uploads/2026-10/09459a3a-9201-4ab7-8319-a05a1cb7bbb9.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "科技賦能品格培養：YADA 品牌橫幅，深色背景上以幾何圖形與節點組成代表教育科技與價值觀教育的圖像",
      "zh-Hans": "科技赋能品格培养：YADA 品牌横幅，深色背景上以几何图形与节点组成代表教育科技与价值观教育的图像",
      "en": "Technology empowering character education: the YADA brand banner, with geometric shapes and nodes on a dark background representing education technology and values education"
    },
    "width": 1200,
    "height": 630
  },
  "a1b36ff8-eea7-44b4-b6ef-b288bde4a001": {
    "urls": {
      "original": "/uploads/2026-10/a1b36ff8-eea7-44b4-b6ef-b288bde4a001.jpg",
      "thumb": "/uploads/2026-10/a1b36ff8-eea7-44b4-b6ef-b288bde4a001.thumb.webp",
      "medium": "/uploads/2026-10/a1b36ff8-eea7-44b4-b6ef-b288bde4a001.medium.webp",
      "small": "/uploads/2026-10/a1b36ff8-eea7-44b4-b6ef-b288bde4a001.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "實用溫習策略：深藍色 YADA 橫幅，左邊是節點組成的網絡圖，中間是標題「實用溫習策略」與副標「從快照到睡眠，六個改變習慣的方法」，右邊是分隔重複的記憶曲線，標示第 1 天首次學習、第 3-4 天主動回想、第 7 天應用所學",
      "zh-Hans": "实用温习策略：深蓝色 YADA 横幅，左边是节点组成的网络图，中间是标题「实用温习策略」与副标「从快照到睡眠，六个改变习惯的方法」，右边是间隔重复的记忆曲线，标示第 1 天首次学习、第 3-4 天主动回想、第 7 天应用所学",
      "en": "Practical revision strategies: a dark blue YADA banner with a node network on the left, the title in the middle, and a spaced-repetition memory curve on the right marking day 1 first learning, days 3-4 active recall, and day 7 applying what you learned"
    },
    "width": 1200,
    "height": 630
  },
  "0404b8e5-a46f-4e28-9d23-6245effe0b77": {
    "urls": {
      "original": "/uploads/2026-10/0404b8e5-a46f-4e28-9d23-6245effe0b77.jpg",
      "thumb": "/uploads/2026-10/0404b8e5-a46f-4e28-9d23-6245effe0b77.thumb.webp",
      "medium": "/uploads/2026-10/0404b8e5-a46f-4e28-9d23-6245effe0b77.medium.webp",
      "small": "/uploads/2026-10/0404b8e5-a46f-4e28-9d23-6245effe0b77.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "",
      "zh-Hans": "",
      "en": ""
    },
    "width": 1380,
    "height": 776
  },
  "56dc0b3d-bdde-4533-893a-633e8dd98d98": {
    "urls": {
      "original": "/uploads/2026-10/56dc0b3d-bdde-4533-893a-633e8dd98d98.jpg",
      "thumb": "/uploads/2026-10/56dc0b3d-bdde-4533-893a-633e8dd98d98.thumb.webp",
      "medium": "/uploads/2026-10/56dc0b3d-bdde-4533-893a-633e8dd98d98.medium.webp",
      "small": "/uploads/2026-10/56dc0b3d-bdde-4533-893a-633e8dd98d98.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "",
      "zh-Hans": "",
      "en": ""
    },
    "width": 1380,
    "height": 1035
  },
  "180836d8-e2bd-4163-863a-5221aab56b96": {
    "urls": {
      "original": "/uploads/2026-10/180836d8-e2bd-4163-863a-5221aab56b96.jpg",
      "thumb": "/uploads/2026-10/180836d8-e2bd-4163-863a-5221aab56b96.thumb.webp",
      "medium": "/uploads/2026-10/180836d8-e2bd-4163-863a-5221aab56b96.medium.webp",
      "small": "/uploads/2026-10/180836d8-e2bd-4163-863a-5221aab56b96.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 710
    },
    "alt": {
      "zh-Hant": "講者手持咪高峰分享觀點，背景可見「IP ZONE 初創專區」活動標識",
      "zh-Hans": "讲者手持咪高峰分享观点，背景可见「IP ZONE 初创专区」活动标识",
      "en": "Speaker holding a microphone while sharing insights, with the \"IP ZONE Startup Zone\" event signage visible in the background."
    },
    "width": 710,
    "height": 473
  },
  "575ee28a-39da-4970-8c8c-dd006c12919f": {
    "urls": {
      "original": "/uploads/2026-10/575ee28a-39da-4970-8c8c-dd006c12919f.jpg",
      "thumb": "/uploads/2026-10/575ee28a-39da-4970-8c8c-dd006c12919f.thumb.webp",
      "medium": "/uploads/2026-10/575ee28a-39da-4970-8c8c-dd006c12919f.medium.webp",
      "small": "/uploads/2026-10/575ee28a-39da-4970-8c8c-dd006c12919f.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 833
    },
    "alt": {
      "zh-Hant": "與會者交流討論環節",
      "zh-Hans": "与会者交流讨论环节",
      "en": "Attendees engaging in discussion during the forum."
    },
    "width": 833,
    "height": 555
  },
  "cd96c6bf-8446-408a-a085-e330a2659f1b": {
    "urls": {
      "original": "/uploads/2026-10/cd96c6bf-8446-408a-a085-e330a2659f1b.jpg",
      "thumb": "/uploads/2026-10/cd96c6bf-8446-408a-a085-e330a2659f1b.thumb.webp",
      "medium": "/uploads/2026-10/cd96c6bf-8446-408a-a085-e330a2659f1b.medium.webp",
      "small": "/uploads/2026-10/cd96c6bf-8446-408a-a085-e330a2659f1b.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "價值觀教育 Priority Values 海報：12 款核心價值卡（國家身份認同、責任感、尊重他人、堅毅、守法、仁愛、誠信、承擔精神、孝親、團結、勤勞、同理心），中英對照",
      "zh-Hans": "价值观教育 Priority Values 海报：12 款核心价值卡（国家身份认同、责任感、尊重他人、坚毅、守法、仁爱、诚信、承担精神、孝亲、团结、勤劳、同理心），中英对照",
      "en": "Priority Values poster: 12 core value cards (national identity, responsibility, respect for others, perseverance, law-abidingness, benevolence, integrity, commitment, filial piety, unity, diligence, empathy), bilingual"
    },
    "width": 2800,
    "height": 2800
  },
  "b5d6e80e-8729-4ff2-9dd2-7c9887cee44e": {
    "urls": {
      "original": "/uploads/2026-10/b5d6e80e-8729-4ff2-9dd2-7c9887cee44e.png",
      "thumb": "/uploads/2026-10/b5d6e80e-8729-4ff2-9dd2-7c9887cee44e.thumb.webp",
      "medium": "/uploads/2026-10/b5d6e80e-8729-4ff2-9dd2-7c9887cee44e.medium.webp",
      "small": "/uploads/2026-10/b5d6e80e-8729-4ff2-9dd2-7c9887cee44e.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1000
    },
    "alt": {
      "zh-Hant": "提取練習：左邊是反覆閱讀的書本與循環箭頭，右邊是從腦中取出知識的箭頭與卡片",
      "zh-Hans": "提取练习：左边是反复阅读的书本与循环箭头，右边是从脑中取出知识的箭头与卡片",
      "en": "Retrieval practice: re-reading a book on the left, pulling a fact out of the brain on the right"
    },
    "width": 1000,
    "height": 1000
  },
  "bcad4cdf-7b21-4ace-b5b2-264d4eb9d155": {
    "urls": {
      "original": "/uploads/2026-10/bcad4cdf-7b21-4ace-b5b2-264d4eb9d155.png",
      "thumb": "/uploads/2026-10/bcad4cdf-7b21-4ace-b5b2-264d4eb9d155.thumb.webp",
      "medium": "/uploads/2026-10/bcad4cdf-7b21-4ace-b5b2-264d4eb9d155.medium.webp",
      "small": "/uploads/2026-10/bcad4cdf-7b21-4ace-b5b2-264d4eb9d155.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1000
    },
    "alt": {
      "zh-Hant": "提問教練：AI 以問號發問，學生面前的練習卡由易到難排列，最後一張是陷阱題",
      "zh-Hans": "提问教练：AI 以问号发问，学生面前的练习卡由易到难排列，最后一张是陷阱题",
      "en": "A questioning coach: AI asks with a question mark while exercise cards progress in difficulty to a trap question"
    },
    "width": 1000,
    "height": 1000
  },
  "d84b0d26-562d-4def-bbb4-0372026956db": {
    "urls": {
      "original": "/uploads/2026-10/d84b0d26-562d-4def-bbb4-0372026956db.png",
      "thumb": "/uploads/2026-10/d84b0d26-562d-4def-bbb4-0372026956db.thumb.webp",
      "medium": "/uploads/2026-10/d84b0d26-562d-4def-bbb4-0372026956db.medium.webp",
      "small": "/uploads/2026-10/d84b0d26-562d-4def-bbb4-0372026956db.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "\\",
      "zh-Hans": "AI 学习伙伴：AI 与孩子并肩同行，孩子自己想出答案，AI 以虚线的建议回应",
      "en": "AI as a study partner: the AI walks alongside the child, who works out the answer while the AI replies with a dashed suggestion"
    },
    "width": 1333,
    "height": 833
  },
  "d42e5f9d-98d7-4f1e-9be0-36aace97f65a": {
    "urls": {
      "original": "/uploads/2026-10/d42e5f9d-98d7-4f1e-9be0-36aace97f65a.png",
      "thumb": "/uploads/2026-10/d42e5f9d-98d7-4f1e-9be0-36aace97f65a.thumb.webp",
      "medium": "/uploads/2026-10/d42e5f9d-98d7-4f1e-9be0-36aace97f65a.medium.webp",
      "small": "/uploads/2026-10/d42e5f9d-98d7-4f1e-9be0-36aace97f65a.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "陪伴孩子溫習：家長與孩子坐在同一張桌旁，中間是列出五個策略的溫習清單，右邊是時鐘",
      "zh-Hans": "陪伴孩子温习：家长与孩子坐在同一张桌旁，中间是列出五个策略的温习清单，右边是时钟",
      "en": "Revising with a child: a parent and child at the same table, a sheet listing five strategies, and a clock"
    },
    "width": 1333,
    "height": 833
  },
  "5d90e25f-64de-4552-a8a0-c0253ad0bc0f": {
    "urls": {
      "original": "/uploads/2026-10/5d90e25f-64de-4552-a8a0-c0253ad0bc0f.png",
      "thumb": "/uploads/2026-10/5d90e25f-64de-4552-a8a0-c0253ad0bc0f.thumb.webp",
      "medium": "/uploads/2026-10/5d90e25f-64de-4552-a8a0-c0253ad0bc0f.medium.webp",
      "small": "/uploads/2026-10/5d90e25f-64de-4552-a8a0-c0253ad0bc0f.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "正向親子關係：家長與孩子面對面，中間是連結兩人的橋與愛心，右邊是因關愛而長大的植物",
      "zh-Hans": "正向亲子关系：家长与孩子面对面，中间是连结两人的桥与爱心，右边是因关爱而长大的植物",
      "en": "A positive parent-child relationship: parent and child face to face, a bridge with a heart between them, and a plant that grew from care"
    },
    "width": 1333,
    "height": 833
  },
  "afde96a9-6c3a-4e07-a99e-fb0c92cb6a90": {
    "urls": {
      "original": "/uploads/2026-10/afde96a9-6c3a-4e07-a99e-fb0c92cb6a90.png",
      "thumb": "/uploads/2026-10/afde96a9-6c3a-4e07-a99e-fb0c92cb6a90.thumb.webp",
      "medium": "/uploads/2026-10/afde96a9-6c3a-4e07-a99e-fb0c92cb6a90.medium.webp",
      "small": "/uploads/2026-10/afde96a9-6c3a-4e07-a99e-fb0c92cb6a90.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "健康數位生活：手機與吸引目光的磁力，中間是連結而非管控的選擇，右邊是日夜各在環內的平衡一天",
      "zh-Hans": "健康数字生活：手机与吸引目光的磁力，中间是连结而非管控的选择，右边是日夜各在环内的平衡一天",
      "en": "A healthy digital life: a phone and the pull of attention, a choice of connection over control, and a balanced day with day and night each in its place"
    },
    "width": 1333,
    "height": 833
  },
  "d1df4006-1a65-4f45-8e32-c02f8effa67b": {
    "urls": {
      "original": "/uploads/2026-10/d1df4006-1a65-4f45-8e32-c02f8effa67b.jpg",
      "thumb": "/uploads/2026-10/d1df4006-1a65-4f45-8e32-c02f8effa67b.thumb.webp",
      "medium": "/uploads/2026-10/d1df4006-1a65-4f45-8e32-c02f8effa67b.medium.webp",
      "small": "/uploads/2026-10/d1df4006-1a65-4f45-8e32-c02f8effa67b.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "專欄圖：左邊是舉著問號的藍色機械人與標題「AI不是給答案，而是出題」，右邊是背著書包爬上梯子的學生，旁邊列出 Spaced Practice 第 1 天首次學習、第 3 天重新回顧、第 7 天長期記憶、Matrix Multiplication Trap 矩陣乘法陷阱，以及「學習挑戰區」",
      "zh-Hans": "专栏图：左边是举着问号的蓝色机器人与标题「AI不是给答案，而是出题」，右边是背书包爬上梯子的学生，旁边列出 Spaced Practice 第 1 天首次学习、第 3 天重新回顾、第 7 天长期记忆、Matrix Multiplication Trap 矩阵乘法陷阱，以及「学习挑战区」",
      "en": "Column illustration: on the left a blue robot holding up a question mark beside the title \"AI does not give answers, it asks questions\"; on the right a student with a backpack climbing a ladder, beside panels listing Spaced Practice (day 1 first learning, day 3 review, day 7 long-term memory), Matrix Multiplication Trap, and the Zone of Proximal Development"
    },
    "width": 1024,
    "height": 1024
  },
  "35fd6df8-394e-42f7-9b45-a26079369d2c": {
    "urls": {
      "original": "/uploads/2026-10/35fd6df8-394e-42f7-9b45-a26079369d2c.jpg",
      "thumb": "/uploads/2026-10/35fd6df8-394e-42f7-9b45-a26079369d2c.thumb.webp",
      "medium": "/uploads/2026-10/35fd6df8-394e-42f7-9b45-a26079369d2c.medium.webp",
      "small": "/uploads/2026-10/35fd6df8-394e-42f7-9b45-a26079369d2c.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "AI 不是給答案，而是出題：左邊是男孩在書桌前做練習卡，腦部插圖旁標示「主動提取」與「檢索練習」，右邊是機器人舉著一個大問號",
      "zh-Hans": "AI 不是给答案，而是出题：左边是男孩在书桌前做练习卡，脑部插图旁标示「主动提取」与「检索练习」，右边是机器人举着一个大问号",
      "en": "AI does not give answers, it asks questions: on the left a boy works through exercise cards at a desk, beside a brain illustration labelled \"active retrieval\" and \"retrieval practice\"; on the right a robot holds up a large question mark"
    },
    "width": 1024,
    "height": 576
  },
  "a8f56618-1aeb-4a0f-bb7c-d66a35686b1d": {
    "urls": {
      "original": "/uploads/2026-10/a8f56618-1aeb-4a0f-bb7c-d66a35686b1d.jpg",
      "thumb": "/uploads/2026-10/a8f56618-1aeb-4a0f-bb7c-d66a35686b1d.thumb.webp",
      "medium": "/uploads/2026-10/a8f56618-1aeb-4a0f-bb7c-d66a35686b1d.medium.webp",
      "small": "/uploads/2026-10/a8f56618-1aeb-4a0f-bb7c-d66a35686b1d.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "YADA講座現場照片：在AI時代陪伴孩子活出健康的數位生活（黃埔宣道小學）",
      "zh-Hans": "YADA讲座现场照片：在AI时代陪伴孩子活出健康的数位生活（黄埔宣道小学）",
      "en": " "
    },
    "width": 1380,
    "height": 1035
  },
  "5fa48586-ff5a-4290-9553-8754f95ba6d7": {
    "urls": {
      "original": "/uploads/2026-10/5fa48586-ff5a-4290-9553-8754f95ba6d7.jpg",
      "thumb": "/uploads/2026-10/5fa48586-ff5a-4290-9553-8754f95ba6d7.thumb.webp",
      "medium": "/uploads/2026-10/5fa48586-ff5a-4290-9553-8754f95ba6d7.medium.webp",
      "small": "/uploads/2026-10/5fa48586-ff5a-4290-9553-8754f95ba6d7.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "YADA講座現場照片：在AI時代陪伴孩子活出健康的數位生活（黃埔宣道小學）",
      "zh-Hans": "YADA讲座现场照片：在AI时代陪伴孩子活出健康的数位生活（黄埔宣道小学）",
      "en": "Photo from YADA's parent talk on healthy digital life in the AI era, at Alliance Primary School, Whampoa"
    },
    "width": 1380,
    "height": 1840
  },
  "af4458a0-8f14-4f87-9823-ebc9606e5e4a": {
    "urls": {
      "original": "/uploads/2026-10/af4458a0-8f14-4f87-9823-ebc9606e5e4a.jpg",
      "thumb": "/uploads/2026-10/af4458a0-8f14-4f87-9823-ebc9606e5e4a.thumb.webp",
      "medium": "/uploads/2026-10/af4458a0-8f14-4f87-9823-ebc9606e5e4a.medium.webp",
      "small": "/uploads/2026-10/af4458a0-8f14-4f87-9823-ebc9606e5e4a.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "YADA講座現場照片：在AI時代陪伴孩子活出健康的數位生活（黃埔宣道小學）",
      "zh-Hans": "YADA讲座现场照片：在AI时代陪伴孩子活出健康的数位生活（黄埔宣道小学）",
      "en": "Photo from YADA's parent talk on healthy digital life in the AI era, at Alliance Primary School, Whampoa"
    },
    "width": 1380,
    "height": 1035
  },
  "95bbb3ae-2b38-476e-92be-ce4c05fb52d0": {
    "urls": {
      "original": "/uploads/2026-10/95bbb3ae-2b38-476e-92be-ce4c05fb52d0.jpg",
      "thumb": "/uploads/2026-10/95bbb3ae-2b38-476e-92be-ce4c05fb52d0.thumb.webp",
      "medium": "/uploads/2026-10/95bbb3ae-2b38-476e-92be-ce4c05fb52d0.medium.webp",
      "small": "/uploads/2026-10/95bbb3ae-2b38-476e-92be-ce4c05fb52d0.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": " ",
      "zh-Hans": " ",
      "en": " "
    },
    "width": 1378,
    "height": 775
  },
  "10091751-1e47-4379-ad16-47b3e2a78054": {
    "urls": {
      "original": "/uploads/2026-10/10091751-1e47-4379-ad16-47b3e2a78054.jpeg",
      "thumb": "/uploads/2026-10/10091751-1e47-4379-ad16-47b3e2a78054.thumb.webp",
      "medium": "/uploads/2026-10/10091751-1e47-4379-ad16-47b3e2a78054.medium.webp",
      "small": "/uploads/2026-10/10091751-1e47-4379-ad16-47b3e2a78054.small.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "魏遠強在錦田公立蒙養學校主講「拆解學生常遇網上騙案／陷阱」教師講座。",
      "zh-Hans": "魏远强在锦田公立蒙养学校主讲「拆解学生常遇网上骗案／陷阱」教师讲座。",
      "en": "YADA executive director Wei Yuanqiang addressing teachers on online fraud prevention at a school seminar in Kam Tin."
    },
    "width": 1200,
    "height": 675
  },
  "8d2d859c-8b8d-4b63-902b-965b9032e4a6": {
    "urls": {
      "original": "/uploads/2026-10/8d2d859c-8b8d-4b63-902b-965b9032e4a6.jpg",
      "thumb": "/uploads/2026-10/8d2d859c-8b8d-4b63-902b-965b9032e4a6.thumb.webp",
      "medium": "/uploads/2026-10/8d2d859c-8b8d-4b63-902b-965b9032e4a6.medium.webp",
      "small": "/uploads/2026-10/8d2d859c-8b8d-4b63-902b-965b9032e4a6.small.webp",
      "large": "/uploads/2026-10/8d2d859c-8b8d-4b63-902b-965b9032e4a6.large.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024,
      "large": 1600
    },
    "alt": {
      "zh-Hant": "SmartCindy AI 升學及就業顧問：戴上耳機的學生微笑作答，背景是香港城市天際線與 AI 網絡圖示",
      "zh-Hans": "SmartCindy AI 升学及就业顾问：戴着耳机的学生微笑作答，背景是香港城市天际线与 AI 网络图标",
      "en": "SmartCindy, the AI further-study and career advisor: a student wearing a headset smiling, with the Hong Kong skyline and an AI network diagram behind"
    },
    "width": 2048,
    "height": 1152
  },
  "fbf3b412-5ac1-4282-bf22-0959d8583583": {
    "urls": {
      "original": "/uploads/2026-11/fbf3b412-5ac1-4282-bf22-0959d8583583.jpg",
      "thumb": "/uploads/2026-11/fbf3b412-5ac1-4282-bf22-0959d8583583.thumb.webp",
      "small": "/uploads/2026-11/fbf3b412-5ac1-4282-bf22-0959d8583583.small.webp",
      "medium": "/uploads/2026-11/fbf3b412-5ac1-4282-bf22-0959d8583583.medium.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "國民教育數碼系統：四大核心支柱，一站式融入校園日常",
      "zh-Hans": "国民教育数码系统：四大核心支柱，一站式融入校园日常",
      "en": "National Education Digital System: four core pillars integrated into everyday school life"
    },
    "width": 1280,
    "height": 720
  },
  "8439f5a7-6f72-41be-9801-133c3157295a": {
    "urls": {
      "original": "/uploads/2026-11/8439f5a7-6f72-41be-9801-133c3157295a.png",
      "thumb": "/uploads/2026-11/8439f5a7-6f72-41be-9801-133c3157295a.thumb.webp",
      "small": "/uploads/2026-11/8439f5a7-6f72-41be-9801-133c3157295a.small.webp",
      "medium": "/uploads/2026-11/8439f5a7-6f72-41be-9801-133c3157295a.medium.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "ValuesIncubator+ 十五項品格卡：寬恕、合作、好奇、欣賞、勇敢、愛學習、仁慈、創意、毅力、判断、誠實、社交智能、謙遜、感恩、謹慎",
      "zh-Hans": "ValuesIncubator+ 十五项品格卡：宽恕、合作、好奇、欣赏、勇敢、爱学习、仁慈、创意、毅力、判断、诚实、社交智能、谦逊、感恩、谨慎",
      "en": "ValuesIncubator+ fifteen character cards: forgiveness, collaboration, curiosity, appreciation, courage, love of learning, kindness, creativity, perseverance, judgement, honesty, social intelligence, humility, gratitude and prudence"
    },
    "width": 1200,
    "height": 1200
  },
  "7dd609dc-45c9-4f3e-b269-81db52c5ff34": {
    "urls": {
      "original": "/uploads/2026-11/7dd609dc-45c9-4f3e-b269-81db52c5ff34.svg",
      "thumb": "/uploads/2026-11/7dd609dc-45c9-4f3e-b269-81db52c5ff34.thumb.webp",
      "small": "/uploads/2026-11/7dd609dc-45c9-4f3e-b269-81db52c5ff34.small.webp",
      "medium": "/uploads/2026-11/7dd609dc-45c9-4f3e-b269-81db52c5ff34.medium.webp",
      "large": "/uploads/2026-11/7dd609dc-45c9-4f3e-b269-81db52c5ff34.large.webp",
      "xlarge": "/uploads/2026-11/7dd609dc-45c9-4f3e-b269-81db52c5ff34.xlarge.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024,
      "large": 1600,
      "xlarge": 2048
    },
    "alt": {
      "zh-Hant": "講座分享：講者向學校師生講解議題，螢幕上顯示上升的數據圖表",
      "zh-Hans": "讲座分享：讲者向学校师生讲解议题，萤幕上显示上升的数据图表",
      "en": "Talks and workshops: a speaker addresses teachers and students in a school hall, with a rising data chart on the screen behind"
    },
    "width": 240,
    "height": 240
  },
  "4670e75a-a055-4f5d-b199-8792ac79ffe6": {
    "urls": {
      "original": "/uploads/2026-11/4670e75a-a055-4f5d-b199-8792ac79ffe6.svg",
      "thumb": "/uploads/2026-11/4670e75a-a055-4f5d-b199-8792ac79ffe6.thumb.webp",
      "small": "/uploads/2026-11/4670e75a-a055-4f5d-b199-8792ac79ffe6.small.webp",
      "medium": "/uploads/2026-11/4670e75a-a055-4f5d-b199-8792ac79ffe6.medium.webp",
      "large": "/uploads/2026-11/4670e75a-a055-4f5d-b199-8792ac79ffe6.large.webp",
      "xlarge": "/uploads/2026-11/4670e75a-a055-4f5d-b199-8792ac79ffe6.xlarge.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024,
      "large": 1600,
      "xlarge": 2048
    },
    "alt": {
      "zh-Hant": "AI 微學習：手機自動派發短小微學習單元，把上學途中與用餐等零碎時間變成有效課室",
      "zh-Hans": "AI 微学习：手机自动派发短小微学习单元，把上学途中与用餐等零碎时间变成有效课室",
      "en": "AI micro-learning: a phone dispenses short micro-lessons, turning the gaps between classes — the journey to school, a meal break — into effective classroom time"
    },
    "width": 240,
    "height": 240
  },
  "0e36ef9e-f14f-405a-bb49-ea1b13f29931": {
    "urls": {
      "original": "/uploads/2026-11/0e36ef9e-f14f-405a-bb49-ea1b13f29931.svg",
      "thumb": "/uploads/2026-11/0e36ef9e-f14f-405a-bb49-ea1b13f29931.thumb.webp",
      "small": "/uploads/2026-11/0e36ef9e-f14f-405a-bb49-ea1b13f29931.small.webp",
      "medium": "/uploads/2026-11/0e36ef9e-f14f-405a-bb49-ea1b13f29931.medium.webp",
      "large": "/uploads/2026-11/0e36ef9e-f14f-405a-bb49-ea1b13f29931.large.webp",
      "xlarge": "/uploads/2026-11/0e36ef9e-f14f-405a-bb49-ea1b13f29931.xlarge.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024,
      "large": 1600,
      "xlarge": 2048
    },
    "alt": {
      "zh-Hant": "AI 升學資訊：搜尋本地升學資料，JUPAS 及八大院校資訊定期更新、全天候提供",
      "zh-Hans": "AI 升学资讯：搜寻本地升学资料，JUPAS 及八大院校资讯定期更新、全天候提供",
      "en": "AI pathways information: a compass beside a search panel, with JUPAS and the eight universities’ information refreshed on a schedule and available around the clock"
    },
    "width": 240,
    "height": 240
  },
  "f858c737-1770-4adf-bbca-3688ebce3d95": {
    "urls": {
      "original": "/uploads/2026-11/f858c737-1770-4adf-bbca-3688ebce3d95.svg",
      "thumb": "/uploads/2026-11/f858c737-1770-4adf-bbca-3688ebce3d95.thumb.webp",
      "small": "/uploads/2026-11/f858c737-1770-4adf-bbca-3688ebce3d95.small.webp",
      "medium": "/uploads/2026-11/f858c737-1770-4adf-bbca-3688ebce3d95.medium.webp",
      "large": "/uploads/2026-11/f858c737-1770-4adf-bbca-3688ebce3d95.large.webp",
      "xlarge": "/uploads/2026-11/f858c737-1770-4adf-bbca-3688ebce3d95.xlarge.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024,
      "large": 1600,
      "xlarge": 2048
    },
    "alt": {
      "zh-Hant": "國民教育：盾牌象徵憲制秩序與法治，書本代表國家歷史與文化，四根支柱承托四大核心",
      "zh-Hans": "国民教育：盾牌象征宪制秩序与法治，书本代表国家历史与文化，四根支柱承托四大核心",
      "en": "National education: a shield symbolising constitutional order and the rule of law, a book standing for national history and culture, and four pillars carrying the four core strands"
    },
    "width": 240,
    "height": 240
  },
  "ff733b3c-c8bc-4f9b-818e-991ebfe37adb": {
    "urls": {
      "original": "/uploads/2026-11/ff733b3c-c8bc-4f9b-818e-991ebfe37adb.jpg",
      "thumb": "/uploads/2026-11/ff733b3c-c8bc-4f9b-818e-991ebfe37adb.thumb.webp",
      "small": "/uploads/2026-11/ff733b3c-c8bc-4f9b-818e-991ebfe37adb.small.webp",
      "medium": "/uploads/2026-11/ff733b3c-c8bc-4f9b-818e-991ebfe37adb.medium.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "香港學生生涯規劃輔導場景",
      "zh-Hans": "香港学生生涯规划辅导场景",
      "en": "Hong Kong students in a career-guidance session"
    },
    "width": 1280,
    "height": 720
  },
  "394a7c00-9d9c-40d6-9d1b-0c06d5194d03": {
    "urls": {
      "original": "/uploads/2026-11/394a7c00-9d9c-40d6-9d1b-0c06d5194d03.png",
      "thumb": "/uploads/2026-11/394a7c00-9d9c-40d6-9d1b-0c06d5194d03.thumb.webp"
    },
    "widths": {
      "thumb": 320
    },
    "alt": {
      "zh-Hant": "CSP 標誌",
      "zh-Hans": "CSP 标志",
      "en": "CSP logo"
    },
    "width": 352,
    "height": 352
  },
  "a0a0c9c2-c062-4bf6-911f-fb37ddc18107": {
    "urls": {
      "original": "/uploads/2026-11/a0a0c9c2-c062-4bf6-911f-fb37ddc18107.jpg",
      "thumb": "/uploads/2026-11/a0a0c9c2-c062-4bf6-911f-fb37ddc18107.thumb.webp",
      "small": "/uploads/2026-11/a0a0c9c2-c062-4bf6-911f-fb37ddc18107.small.webp",
      "medium": "/uploads/2026-11/a0a0c9c2-c062-4bf6-911f-fb37ddc18107.medium.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "FuturePath 行業心智圖",
      "zh-Hans": "FuturePath 行业心智图",
      "en": "FuturePath industry mind map"
    },
    "width": 1100,
    "height": 520
  },
  "467427c2-d297-4856-932c-c587b7ca9cb0": {
    "urls": {
      "original": "/uploads/2026-11/467427c2-d297-4856-932c-c587b7ca9cb0.jpg",
      "thumb": "/uploads/2026-11/467427c2-d297-4856-932c-c587b7ca9cb0.thumb.webp",
      "small": "/uploads/2026-11/467427c2-d297-4856-932c-c587b7ca9cb0.small.webp",
      "medium": "/uploads/2026-11/467427c2-d297-4856-932c-c587b7ca9cb0.medium.webp"
    },
    "widths": {
      "thumb": 320,
      "small": 640,
      "medium": 1024
    },
    "alt": {
      "zh-Hant": "精選故事行業影片與工作紙",
      "zh-Hans": "精选故事行业影片与工作纸",
      "en": "Featured Stories industry video and worksheet"
    },
    "width": 1100,
    "height": 640
  },
  "1af582e3-3878-4bb1-924d-27ee68a655e6": {
    "urls": {
      "original": "/uploads/2026-11/1af582e3-3878-4bb1-924d-27ee68a655e6.png",
      "thumb": "/uploads/2026-11/1af582e3-3878-4bb1-924d-27ee68a655e6.thumb.webp"
    },
    "widths": {
      "thumb": 320
    },
    "alt": {
      "zh-Hant": "CSP WhatsApp 查詢二維碼",
      "zh-Hans": "CSP WhatsApp 查询二维码",
      "en": "QR code for the CSP WhatsApp enquiry"
    },
    "width": 348,
    "height": 348
  }
}
